import { useAppDispatch } from '../../../shared/lib/hooks/useAppDispatch/useAppDispatch'
import { useAppSelector } from '../../../shared/lib/hooks/useAppSelector/useAppSelector'
import { modalActions, selectModalData } from '../../../entities/Modal'
import { ChangeStateModal } from '../../../shared/ui/ChangeStateModal/ChangeStateModal'
import { deleteClientLabel } from '../model/services/deleteClientLabel'
import { ClientLabelWithId } from '../../../entities/ClientLabel'

export const DeleteClientLabelModal = () => {

	const dispatch = useAppDispatch()
	const data = useAppSelector(selectModalData) as ClientLabelWithId

	const header = (
		<>
			Please confirm that you want to delete <i>{data.labelName}</i> label
		</>
	)

	const handleConfirm = async () => {
		const result = await dispatch(deleteClientLabel(data.labelId))
		if (result.meta.requestStatus === 'fulfilled') {
			dispatch(modalActions.hideModal())
		}
	}

	return (
		<ChangeStateModal
			handleConfirm={handleConfirm}
			headerMsg={header}
		/>
	)
}